import { useEffect } from "react";
import Head from "next/head";

import { trackEvent } from "dapp-sdk-v2";
import { getQueryString } from "@utils/common";
const XTokenPage = () => {
  useEffect(() => {
    trackEvent("PAGE_LOAD_BNBX");
  }, []);

  if (typeof window !== "undefined") {
    const origin = window?.location?.origin || "https://www.staderlabs.com";
    const metaContent = `0; url='${origin}/bnb/stake/`;
    const queryString = getQueryString(window?.location?.search || "");

    return (
      <Head>
        <meta
          httpEquiv="Refresh"
          content={`${metaContent}${queryString ? `?${queryString}` : ""}`}
        />
      </Head>
    );
  }
  return null;
};

export default XTokenPage;
